// extracted by mini-css-extract-plugin
module.exports = {"container":"_2dae1","label":"_3xzHT","spacing":"_1TGd9","tooltip":"_2jOUe"};